import styled from "styled-components";

export type LoadVariant = "default" | "solid-black";

export const LoadStyle = styled.div<{ $variant?: LoadVariant }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  border: 0;
  background-color: ${({ $variant }) =>
    $variant === "solid-black" ? "#000" : "rgba(0, 0, 0, 0.5)"};
`;